import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Sugestões padrão de países (podem ser complementadas pela lista cadastrada).
const PAISES_COMUNS = [
  "Brasil", "Argentina", "Chile", "Colômbia", "Paraguai", "Uruguai",
  "Estados Unidos", "Portugal", "Bolívia", "Peru", "Equador", "Venezuela",
  "México", "Espanha", "França", "Itália", "Alemanha", "Reino Unido",
];

// Campo País: combobox pesquisável com TEXTO LIVRE. Aceita selecionar um país existente
// (autocomplete) OU digitar manualmente qualquer outro. Não bloqueia países novos.
export function PaisInput({ value, onChange, opcoes = [], testid = "aluno-pais", label = "País", className = "" }) {
  const listId = `${testid}-list`;
  const nomes = [
    ...opcoes.map((p) => (typeof p === "string" ? p : p.nome)).filter(Boolean),
    ...PAISES_COMUNS,
  ];
  const unicos = Array.from(new Set(nomes.map((n) => n.trim()).filter(Boolean)));

  return (
    <div className={className}>
      {label !== null && <Label>{label}</Label>}
      <Input
        data-testid={testid}
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Selecione ou digite (ex.: Brasil, Chile, Argentina)"
        autoComplete="off"
      />
      <datalist id={listId}>
        {unicos.map((n) => <option key={n} value={n} />)}
      </datalist>
    </div>
  );
}
